window.MaissonDesign.register(({on,cleanup}) => {
if (!document.getElementById('book-configurator')) return;
const mainImage = document.querySelector('#main-photo');
const thumbs = [...document.querySelectorAll('.thumbnails button')];
const dialog = document.querySelector('#image-dialog');
const galleryVideos = [...document.querySelectorAll('.mm-gallery-video')];
function pauseGalleryVideos() { galleryVideos.forEach(video => { video.pause(); video.hidden = true; }); }
cleanup(pauseGalleryVideos);
on(document, 'visibilitychange', () => { if (document.hidden) galleryVideos.forEach(video => video.pause()); });
function photoKeyFromUrl(src) {
  try { return new URL(src, document.baseURI).pathname.split('/').pop(); } catch { return src; }
}
function showProductPhoto(src, alt) {
  if (!src) return;
  pauseGalleryVideos();
  document.querySelector('.zoom').hidden = false;
  mainImage.src = src;
  mainImage.alt = alt || productConfig.title || '';
  mainImage.hidden = false;
  mainImage.classList.remove('fixed-cover-photo');
  const styleName = document.getElementById('gallery-style-name');
  if (styleName) styleName.hidden = true;
  const index = thumbs.findIndex(thumb => photoKeyFromUrl(thumb.dataset.fullSrc) === photoKeyFromUrl(src));
  thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
  const counter = document.querySelector('#photo-index');
  if (counter) counter.textContent = index < 0 ? '—' : String(index + 1);
  const photoLabel = document.querySelector('.photo-label');
  if (photoLabel) photoLabel.hidden = index < 0;
  if (index >= 0) {
    const thumb = thumbs[index];
    const strip = thumb.parentElement;
    if (thumb.offsetLeft < strip.scrollLeft) strip.scrollLeft = thumb.offsetLeft;
    else if (thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = thumb.offsetLeft + thumb.offsetWidth - strip.clientWidth;
  }
  if (dialog.open) {
    dialog.querySelector('img').src = mainImage.src;
    dialog.querySelector('img').alt = mainImage.alt;
  }
}
thumbs.forEach(button => on(button, 'click', () => {
  if (button.dataset.videoId) {
    const video = document.getElementById(button.dataset.videoId);
    if (!video) return;
    pauseGalleryVideos();
    mainImage.hidden = true;
    document.querySelector('.zoom').hidden = true;
    document.querySelector('.photo-label').hidden = true;
    thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    if (dialog.open) dialog.close();
    video.hidden = false;
    video.play().catch(() => {});
    return;
  }
  const style = coverStyleInputs.find(input => photoKeyFromUrl(input.dataset.image) === photoKeyFromUrl(button.dataset.fullSrc));
  if (style) { style.checked = true; updateCoverStyle(); }
  else showProductPhoto(button.dataset.fullSrc, button.dataset.alt);
}));
on(document.querySelector('.zoom'), 'click', () => {
  dialog.querySelector('img').src = mainImage.src;
  dialog.querySelector('img').alt = mainImage.alt;
  dialog.showModal();
});
on(dialog.querySelector('.close'), 'click', () => dialog.close());
on(dialog, 'click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });

const form = document.querySelector('#book-configurator');
const quantity = document.querySelector('#quantity');
const productConfig = JSON.parse(document.getElementById('product-config')?.textContent || '{}');
const strings = JSON.parse(document.getElementById('mm-product-i18n')?.textContent || '{}');
const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{'+name+'}', String(value)), strings[key] || key);
const displayed = input => input?.dataset.displayValue || input?.value || '';
const coverStyleInputs = [...form.querySelectorAll('input[name="properties[Cover style]"]')];
function updateCoverStyle(showImage = true) {
  const selected = coverStyleInputs.find(input => input.checked);
  if (!selected) return;
  if (showImage || photoKeyFromUrl(mainImage.src) === photoKeyFromUrl(selected.dataset.image)) {
    showProductPhoto(selected.dataset.image, selected.dataset.imageAlt);
    mainImage.classList.add('fixed-cover-photo');
    document.getElementById('gallery-style-name').textContent = displayed(selected);
    document.getElementById('gallery-style-name').hidden = false;
  }
  document.getElementById('selected-cover-image').value = selected.dataset.image;
  if (dialog.open) {
    dialog.querySelector('img').src = mainImage.src;
    dialog.querySelector('img').alt = mainImage.alt;
  }
}
coverStyleInputs.forEach(input => on(input, 'click', updateCoverStyle));
updateCoverStyle(false);
const variants = productConfig.variants || [];
const core = window.MaissonVariants;
const variantInput = form.querySelector('input[name="id"]');
const productPrice = document.querySelector('.product-info .price');
const stockStatus = document.getElementById('mm-variant-status');
const cartButton = document.getElementById('review-add-cart');
const buyButton = document.getElementById('review-buy-now');
const orderReady = form.dataset.orderingReady === 'true';
const initialCover = {src: mainImage.src, alt: mainImage.alt};
let displayedVariantId = currentVariant()?.id ?? null;
function updateVariantImage(variant) {
  if (productConfig.handle !== 'the-travel-edition') return;
  const cover = variant?.image || initialCover;
  showProductPhoto(cover.src, cover.alt);
}
function selectedOptions() { return [...form.querySelectorAll('[data-variant-option]')].map(group => group.querySelector('input:checked')?.value); }
function currentVariant() { return core.match(variants, selectedOptions()); }
function selectedUnitPrice() { return currentVariant()?.priceText || t('unavailable_combination'); }
function updateSelection(updateUrl = false) {
  const variant = currentVariant();
  if (displayedVariantId !== (variant?.id ?? null)) {
    updateVariantImage(variant);
    displayedVariantId = variant?.id ?? null;
  }
  const canBuy = core.purchasable(variant);
  const rules = core.rules(variant);
  productPrice.textContent = selectedUnitPrice();
  const compare = document.getElementById('mm-compare-price');
  compare.hidden = !variant?.compareAtText; compare.textContent = variant?.compareAtText || '';
  const selectedColor = form.querySelector('[data-variant-option] .swatch-options input:checked');
  if (selectedColor) document.getElementById('color-name').textContent = displayed(selectedColor);
  variantInput.value = variant ? String(variant.id) : '';
  variantInput.disabled = !orderReady || !canBuy;
  quantity.min = String(rules.min); quantity.step = String(rules.step);
  if (rules.max == null) quantity.removeAttribute('max'); else quantity.max = String(rules.max);
  document.getElementById('decrease').disabled = !canBuy || Number(quantity.value) <= rules.min;
  document.getElementById('increase').disabled = !canBuy || (rules.max != null && Number(quantity.value) + rules.step > rules.max);
  cartButton.disabled = !orderReady || !canBuy;
  buyButton.disabled = !orderReady || !canBuy;
  cartButton.textContent = !variant ? t('unavailable') : !canBuy ? t('sold_out') : t('add_cart');
  stockStatus.textContent = !variant ? t('combination_help') : !canBuy ? t('sold_help') : '';
  if (updateUrl) { const url = new URL(location.href); if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant'); history.replaceState({},'',url); }
}
on(form,'change',event => { if (event.target.matches('[data-option-position]')) { quantity.value = core.normalize(quantity.value,currentVariant()); updateSelection(true); } });
on(form,'click',event => { if (event.target.matches('.swatch-options input')) updateVariantImage(currentVariant()); });
on(quantity,'change',()=>{ quantity.value = core.normalize(quantity.value,currentVariant()); updateSelection(); });
for (const [id,delta] of [['decrease',-1],['increase',1]]) on(document.getElementById(id),'click',()=>{ quantity.value = core.normalize(Number(quantity.value)+delta*core.rules(currentVariant()).step,currentVariant()); updateSelection(); });
on(window,'popstate',()=>{ const id = new URL(location.href).searchParams.get('variant') || String(productConfig.selectedVariantId); const variant = variants.find(v=>String(v.id)===id); if (!variant) return; form.querySelectorAll('[data-option-position]').forEach(input=>{input.checked = input.value===variant.options[Number(input.dataset.optionPosition)-1];}); quantity.value=core.normalize(quantity.value,variant);updateSelection(); });
function uploadProblem() {
  const panel = form.querySelector('.mm-uploadkit-panel');
  return window.MaissonOrder.check({
    ready: !!panel && panel.querySelector('.mm-uploadkit-status')?.hidden === true,
    handle: productConfig.handle,
    options: selectedOptions(),
    fields: [...(panel?.querySelectorAll('.uploadkit-upload-field') || [])].map(field => ({
      kind: field.dataset.mmKind,
      invalid: field.getAttribute('invalid') === 'true',
      values: [...field.querySelectorAll('.uploadkit-attribute-container input[type="hidden"][name^="properties["]')].filter(input => !input.disabled && !input.name.startsWith('properties[_')).map(input => input.value.trim())
    }))
  });
}
on(form,'submit',event=>{
  const problem = !orderReady || !core.purchasable(currentVariant()) ? 'draft_locked' : uploadProblem();
  if (!problem) { document.getElementById('mm-stage-status').textContent = ''; return; }
  event.preventDefault();
  event.stopImmediatePropagation();
  const notice = document.getElementById('mm-stage-status');
  notice.textContent = t(problem);
  notice.scrollIntoView({block:'center',behavior:'smooth'});
  if (problem.startsWith('upload_')) form.querySelector(`[data-mm-kind="${problem === 'upload_cover' ? 'cover' : 'photos'}"] .uploadkit-button`)?.focus({preventScroll:true});
},{capture:true});
const photoGroups = [
  {input:'trip-photos', previews:'trip-previews', status:'trip-status', clear:'clear-trip', empty:t('select_many'), urls:[]},
  {input:'cover-photo', previews:'cover-preview', status:'cover-status', clear:'clear-cover', empty:t('choose_one'), urls:[]}
];
const photoCaptions = form.maisonDraftCaptions ||= new Map();
const photoKey = file => JSON.stringify([file.name, file.size, file.lastModified]);
function renderPhotoCaptions(files) {
  const section = document.getElementById('photo-captions');
  if (!section) return;
  section.hidden = !files.length;
  const fields = document.getElementById('photo-caption-fields');
  fields.replaceChildren();
  files.forEach((file, index) => {
    const label = document.createElement('label');
    const input = document.createElement('textarea');
    input.id = `photo-caption-${index}`;
    input.rows = 2; input.dir = 'auto';
    input.maxLength = 1000;
    input.placeholder = t('caption_placeholder');
    input.value = photoCaptions.get(photoKey(file)) || '';
    on(input, 'input', () => photoCaptions.set(photoKey(file), input.value));
    label.htmlFor = input.id;
    label.textContent = `${index + 1}. ${file.name}`;
    fields.append(label, input);
  });
}
for (const group of photoGroups) {
  const input = document.getElementById(group.input);
  const clear = document.getElementById(group.clear);
  if (!input || !clear) continue;
  const render = () => {
    group.urls.forEach(URL.revokeObjectURL);
    group.urls = [];
    const container = document.getElementById(group.previews);
    container.replaceChildren();
    const files = [...input.files];
    if (group.input === 'trip-photos') renderPhotoCaptions(files);
    document.getElementById(group.status).textContent = files.length ? (document.documentElement.lang === 'ar' ? t('selected_device', {count:files.length}) : `${files.length} photograph${files.length === 1 ? '' : 's'} selected on this device`) : group.empty;
    clear.hidden = !files.length;
    for (const file of files.slice(0, 6)) {
      const image = document.createElement('img');
      const url = URL.createObjectURL(file);
      group.urls.push(url);
      image.src = url;
      image.alt = file.name;
      image.onerror = () => { const name = document.createElement('span'); name.textContent = file.name; image.replaceWith(name); };
      container.append(image);
    }
    if (files.length > 6) { const more = document.createElement('span'); more.textContent = `+${files.length - 6}`; container.append(more); }
  };
  if (input.files.length) render();
  on(input, 'change', render);
  on(clear, 'click', () => { input.value = ''; render(); });
}
const review = document.getElementById('review-dialog');
on(form.querySelector('.review-book-link'), 'click', event => {
  event.preventDefault();
  const uploadKit = form.querySelector('.mm-uploadkit-panel');
  const localPhotos = document.getElementById('trip-photos');
  const localCover = document.getElementById('cover-photo');
  const values = [
    ...(coverStyleInputs.length ? [[t('cover_style'), displayed(coverStyleInputs.find(input => input.checked))]] : []),
    ...[...form.querySelectorAll('[data-variant-option]')].map(group => { const input = group.querySelector('input:checked'); return [input?.dataset.optionLabel, displayed(input)]; }), [t('unit_price'), selectedUnitPrice()], [t('quantity'), quantity.value],
    ...(!uploadKit ? [[productConfig.titleLabel || t('destination'), form.elements.destination?.value || t('not_provided')],
    ...(form.elements.subtitle ? [[t('subtitle'), form.elements.subtitle.value || t('not_provided')]] : []),
    [productConfig.titleLabel ? t('book_photos') : t('trip_photos'), t('selected', {count:localPhotos?.files.length || 0})],
    [t('cover_photograph'), localCover?.files[0]?.name || t('designer_select')],
    [t('opening_message'), form.elements.message?.value || t('none')], [t('requests'), form.elements.requests?.value || t('none')]] : [])
  ];
  if (uploadKit) {
    for (const input of uploadKit.querySelectorAll('[data-uploadkit-fallback]:not(:disabled)')) {
      values.push([input.closest('[data-uploadkit-slot]').querySelector('.mm-field-label').textContent, input.value.trim() || t('not_provided')]);
    }
    for (const field of uploadKit.querySelectorAll('.uploadkit-uploader')) {
      const label = field.dataset.mmLabel || field.querySelector('.uploadkit-label')?.textContent.trim();
      const inputs = [...field.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')];
      const entries = inputs.filter(input => !input.disabled && !input.name.startsWith('properties[_') && (!['checkbox','radio'].includes(input.type) || input.checked)).map(input => input.value.trim()).filter(Boolean);
      if (label) values.push([label, entries.length && field.classList.contains('uploadkit-upload-field') ? uploadKit.dataset.uploadedLabel : entries.join('\n') || t('not_provided')]);
    }
    if (!uploadKit.querySelector('.uploadkit-uploader')) values.push([t('book_photos'), document.querySelector('.mm-uploadkit-status').textContent]);
  }
  if (productConfig.photoCaptions && localPhotos) {
    for (const file of localPhotos.files) {
      const caption = photoCaptions.get(photoKey(file));
      if (caption?.trim()) values.push([t('text_for', {name:file.name}), caption]);
    }
  }
  const list = document.getElementById('review-selections'); list.replaceChildren();
  const purchaseStatus = document.getElementById('review-purchase-status');
  purchaseStatus.hidden = true;
  purchaseStatus.textContent = '';
  for (const [label, value] of values) {
    const dt = document.createElement('dt'); const dd = document.createElement('dd');
    dt.textContent = label; dd.dir = 'auto';
    const range = document.documentElement.lang === 'ar' && String(value).match(/^(\d+–\d+)(.*)$/);
    if (range) { const number = document.createElement('bdi'); number.dir='ltr'; number.textContent=range[1]; dd.append(number, document.createTextNode(range[2])); }
    else dd.textContent = value;
    list.append(dt, dd);
  }
  review.showModal();
});
on(document.getElementById('close-review'), 'click', () => review.close());
on(document.getElementById('edit-book'), 'click', () => review.close());
updateSelection();
cleanup(() => photoGroups.forEach(group => group.urls.forEach(URL.revokeObjectURL)));
});
